// Libs
import './libs/index';

// Custom functions
import * as customFunctions from './modules/functions';

// customFunctions.copyrightLink();
// customFunctions.disableRightClick();
customFunctions.scrollToTopBtn();
customFunctions.img_lightbox();
customFunctions.addCssToNextAfterAyat();
customFunctions.curentAyatSuraLinkStyling();

// Styles
import '../scss/index.scss';
import {curentAyatSuraLinkStyling, disableRightClick} from "./modules/functions";

